import {useEffect, useState} from "react";
import {USUARIO} from "../../../util";
import {logado} from "../../../util/usuario-util";
import MenuUsuario from './menu-usuario';
import {Container, Group, Text} from "@mantine/core";
import classes from "./menu-topo.module.css";

export default function MenuTopo(props: any) {

    const [objeto, setObjeto] = useState({
        nome: '',
        primeiroNome: '',
        usuario: '',
        email: '',
        busca: '',
        ativo: '',
        setor: ''
    });

    const [loader, setLoader] = useState({})

    function setNome() {
        if (!logado()) return "";
        const usuario = JSON.parse(localStorage.getItem(USUARIO) as string)
        setObjeto({...objeto,
            nome: usuario.nome.trim(),
            primeiroNome: usuario.primeiroNome.trim(),
            usuario: usuario.usuario.trim(),
            email: usuario.email.trim(),
            setor: (usuario.setor === null ? 'Sem Setor Definido': usuario.setor.nome.trim()),
        })
    }

    useEffect(() => {
        setNome();
        setLoader(props.isCarregando ? 'visible' : 'invisible')
    }, [])

    if (!logado()) return <></>;
  return (
      <>
        <Container className={classes.header}>
          Setor: &nbsp;<b>{objeto.setor}</b>
        </Container>
        <Container>
          <Text> &nbsp; </Text>
        </Container>
        <Container size="md" className={classes.headerBotoes}>
          <Group gap={5} visibleFrom="xxs" mr={10}>
            {/*<Notificacoes />*/}
          </Group>
          <Group gap={5} visibleFrom="xxs">
            <MenuUsuario />
          </Group>

        </Container>
      </>
    );
}
